const VerticalLayout = () => import('@/layouts/VerticalLayout')

const promostionslist = () => import('./views/list')

export default [
  {
    path: '/all-promotions',
    name: 'promostionslist',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'promostionslist',
      meta: { name: 'promostionslist', userType: 'admin', permission: 'all_service_promotions' },
      component: promostionslist
    }
    ]
  }
]
